import { KMStackEventBus } from 'kmstack-shared/utils';
import { KMStackEvents } from './kmstack-event';

const eventBus = new KMStackEventBus<KMStackEvents>(
    typeof BroadcastChannel === 'undefined' ? undefined : new BroadcastChannel('kmstack-eventbus')
);

export default eventBus;
export { eventBus };
